import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { Stack } from "@mui/material";
import { LoadingButton } from "@mui/lab";

import { number, object, string } from "yup";
import { useProtectedAxiosInstance } from "../../hooks/axiosInstance";
import errorResolver from "../../utils/error-resolver";
import { useNotificationContext } from "../../context/notificationContext";
import MuiTextField from "../../components/common/text-field/MuiTextField";

import { RolesListRequest } from "../../services/Endpoints/roles/RolesListEndpoint";
import { IUsers } from "../../components/panel/users/UsersTable";
import MuiSelect from "../../components/common/select/MuiSelect";
import { WorkspaceListRequest } from "../../services/Endpoints/workspaces";
import { AclRoleUsersListRequest } from "../../services/Endpoints/roles/RoleUserEndpoint";

interface IUserEditFormProps {
  onClose: () => void;
  userInfo?: Omit<IUsers, "operations"> | null;
}

export default function UserEditForm({
  onClose,
  userInfo,
}: Readonly<IUserEditFormProps>) {
  const [waiting, setWaiting] = useState(false);
  const [options, setOptions] = useState<{ value: string; label: string }[]>(
    []
  );
  const [workspaces, setWorkspaces] = useState<
    { value: string; label: string }[]
  >([]);

  const { setNotification } = useNotificationContext();
  const protectedInstance = useProtectedAxiosInstance();

  const getData = async () => {
    const rolesList = new RolesListRequest(protectedInstance);
    const workspaceList = new WorkspaceListRequest(protectedInstance);
    try {
      const { data } = await rolesList.send({ count: 1000 });
      console.log(data);
      setOptions(
        data.acl_roles.map((role) => ({
          value: role.id.toString(),
          label: role.caption,
        }))
      );
      const {
        data: { workspaces },
      } = await workspaceList.send({ count: 100 });
      setWorkspaces(
        workspaces.data.map(({ id, name }) => ({
          value: id.toString(),
          label: name,
        }))
      );
    } catch (error) {
      console.error(error);
      errorResolver({ error, setNotification });
    }
  };

  useEffect(() => {
    getData();
  }, [userInfo]);

  const loginSchema = object({
    user_id: number().required(),
    acl_role_id: number().required(),
    workspace_id: number().nullable(),
  });

  const formik = useFormik({
    initialValues: {
      user_id: userInfo?.id,
      acl_role_id: "",
      workspace_id: "",
    },
    validationSchema: loginSchema,
    onSubmit: async (values) => {
      setWaiting(true);
      const aclRoleUserRequest = new AclRoleUsersListRequest(protectedInstance);
      try {
        const { data } = await aclRoleUserRequest.create({
          acl_role_id: Number(values.acl_role_id),
          user_id: userInfo?.id ?? 1,
          workspace_id: values.workspace_id
            ? Number(values.workspace_id)
            : null,
        });
        formik.resetForm();
        setWaiting(false);
        onClose();
      } catch (error: any) {
        errorResolver({ error, setNotification });
        setWaiting(false);
        formik.resetForm();
      }
    },
    enableReinitialize: true,
  });

  return (
    <Stack
      maxWidth="95%"
      width={{ xs: "95%", sm: "97%" }}
      gap="20.31px"
      mx="10px"
      component="form"
      onSubmit={formik.handleSubmit}
    >
      <MuiTextField
        width="100%"
        name="mobile"
        inputMode={"numeric"}
        type="text"
        // placeholder={infos.placeholder}
        label={"شمارتماس"}
        disabled
        value={userInfo?.mobile}
        // handleChange={formik.handleChange}
        // Example={infos.Example}
        // error={
        //   formik.touched.mobile &&
        //   Boolean(formik.errors.mobile) &&
        //   formik.errors.mobile
        // }
      />
      <MuiSelect
        width="100%"
        name="acl_role_id"
        options={
          options.length > 0 ? options : [{ value: "1", label: "مدیر کل" }]
        }
        label={"نقش"}
        value={formik.values.acl_role_id}
        handleChange={formik.handleChange}
        error={
          formik.touched.acl_role_id &&
          Boolean(formik.errors.acl_role_id) &&
          formik.errors.acl_role_id
        }
      />
      <MuiSelect
        width="100%"
        name="workspace_id"
        options={
          workspaces.length > 0
            ? workspaces
            : [{ value: "1", label: "مدیر کل" }]
        }
        label={"شناسه تخته"}
        value={formik.values.workspace_id}
        handleChange={formik.handleChange}
        error={
          formik.touched.workspace_id &&
          Boolean(formik.errors.workspace_id) &&
          formik.errors.workspace_id
        }
      />

      <LoadingButton variant="confirm" type="submit" loading={waiting}>
        تایید
      </LoadingButton>
    </Stack>
  );
}
//
